// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-skeleton>*[data-v-38e6e53c]{margin-bottom:var(--spaces-2xl)}@media(min-width:768px){.home-skeleton>*[data-v-38e6e53c]{margin-bottom:var(--spaces-3xl)}}.home-skeleton__banner[data-v-38e6e53c]{height:270px;border-radius:var(--radius-l)}@media(min-width:1200px){.home-skeleton__banner[data-v-38e6e53c]{height:360px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
